import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import { CSVLink } from 'react-csv';

import Typography from '@material-ui/core/Typography';
import PeopleIcon from '@material-ui/icons/People';

import Paper from '~/components/Paper';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import Button from '~/components/Button';

import LinearProgress from '~/components/LinearProgress';

import Request from '~/providers/Request';

import InputMonthPicker from '~/components/Input/InputMonthPicker';

function MedicalReport() {
  const { t } = useTranslation();

  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());

  const [appointmentsByMonth, setAppointmentsByMonth] = useState([]);
  const [appointmentsByMonthCount, setAppointmentsByMonthCount] = useState([]);

  const [loading, setLoading] = useState(false);
  const [csvData, setCSVdata] = useState([]);

  const getBarUsersByMonth = () => {
    return {
      labels: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ],
      datasets: [
        {
          label: t('dashboard.attributes.appointments_per_day'),
          borderWidth: 1,
          backgroundColor: '#40BDA7',
          borderColor: '#40BDA7',
          hoverBackgroundColor: '#40BDA7',
          hoverBorderColor: '#40BDA7',
          data: appointmentsByMonthCount,
        },
      ],
    };
  };

  const BarLineOptions = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            fontSize: 14,
            maxTicksLimit: 31,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            padding: 10,
            fontSize: 16,
          },
          gridLines: {
            color: 'rgb(234, 236, 244)',
            zeroLineColor: 'rgb(234, 236, 244)',
            drawBorder: false,
          },
        },
      ],
    },
    legend: {
      labels: {
        fontSize: 16,
      },
    },
    tooltips: {
      backgroundColor: 'rgb(255,255,255)',
      bodyFontColor: '#858796',
      titleMarginBottom: 10,
      titleFontColor: '#6e707e',
      titleFontSize: 18,
      borderColor: '#dddfeb',
      borderWidth: 1,
      xPadding: 20,
      yPadding: 20,
      displayColors: false,
      intersect: false,
      mode: 'index',
      caretPadding: 10,
    },
  };

  useEffect(() => {
    downloadCSV();
  }, [appointmentsByMonth]);

  const downloadCSV = async () => {
    const list = [];

    const month = moment(dataInit).format('MM');
    const year = moment(dataInit).format('YYYY');

    list.push([
      `${moment(dataInit).format('MMMM')}/${year}`,
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
    ]);

    for ( let i = 1 ; i < 32 ; i++ ) {
      const newDay = i < 10 ? `0${i}` : i;
      const newData = `${year}-${month}-${newDay}T00:00:00-03:00`;
      const weekDay = moment(newData).format('dddd');
      const selectedMonth = appointmentsByMonth[i-1];

      if (selectedMonth && weekDay !== 'Data inválida') {
        list.push([`${i} - ${weekDay}`,
          selectedMonth.find(item => item.hour === 0) ? selectedMonth.find(item => item.hour === 0).count : 0,
          selectedMonth.find(item => item.hour === 1) ? selectedMonth.find(item => item.hour === 1).count : 0,
          selectedMonth.find(item => item.hour === 2) ? selectedMonth.find(item => item.hour === 2).count : 0,
          selectedMonth.find(item => item.hour === 3) ? selectedMonth.find(item => item.hour === 3).count : 0,
          selectedMonth.find(item => item.hour === 4) ? selectedMonth.find(item => item.hour === 4).count : 0,
          selectedMonth.find(item => item.hour === 5) ? selectedMonth.find(item => item.hour === 5).count : 0,
          selectedMonth.find(item => item.hour === 6) ? selectedMonth.find(item => item.hour === 6).count : 0,
          selectedMonth.find(item => item.hour === 7) ? selectedMonth.find(item => item.hour === 7).count : 0,
          selectedMonth.find(item => item.hour === 8) ? selectedMonth.find(item => item.hour === 8).count : 0,
          selectedMonth.find(item => item.hour === 9) ? selectedMonth.find(item => item.hour === 9).count : 0,
          selectedMonth.find(item => item.hour === 10) ? selectedMonth.find(item => item.hour === 10).count : 0,
          selectedMonth.find(item => item.hour === 11) ? selectedMonth.find(item => item.hour === 11).count : 0,
          selectedMonth.find(item => item.hour === 12) ? selectedMonth.find(item => item.hour === 12).count : 0,
          selectedMonth.find(item => item.hour === 13) ? selectedMonth.find(item => item.hour === 13).count : 0,
          selectedMonth.find(item => item.hour === 14) ? selectedMonth.find(item => item.hour === 14).count : 0,
          selectedMonth.find(item => item.hour === 15) ? selectedMonth.find(item => item.hour === 15).count : 0,
          selectedMonth.find(item => item.hour === 16) ? selectedMonth.find(item => item.hour === 16).count : 0,
          selectedMonth.find(item => item.hour === 17) ? selectedMonth.find(item => item.hour === 17).count : 0,
          selectedMonth.find(item => item.hour === 18) ? selectedMonth.find(item => item.hour === 18).count : 0,
          selectedMonth.find(item => item.hour === 19) ? selectedMonth.find(item => item.hour === 19).count : 0,
          selectedMonth.find(item => item.hour === 20) ? selectedMonth.find(item => item.hour === 20).count : 0,
          selectedMonth.find(item => item.hour === 21) ? selectedMonth.find(item => item.hour === 21).count : 0,
          selectedMonth.find(item => item.hour === 22) ? selectedMonth.find(item => item.hour === 22).count : 0,
          selectedMonth.find(item => item.hour === 23) ? selectedMonth.find(item => item.hour === 23).count : 0
        ]);
      }
    }

    setCSVdata(list);
    setLoading(false);
  };

  const fetchAppointments = async () => {
    setLoading(true);
    Request.get(
      '/admin/dashboard/appointments_by_month_with_hour',
      { start: dataInit, end: dataEnd },
      { normalizeJSON: false }
    )
      .then((response) => {
        setAppointmentsByMonth(response.medicalAppointmentsByMonth);

        const medicalAppointmentsMonth = [];
        for (let i = 0; i <= 31; i++) {
          const day = response.medicalAppointmentsByMonth[i];
          let soma = 0;
          if (day) {
            day.map((item) => {
              soma = soma + item.hour;
            });
          }

          medicalAppointmentsMonth.push(soma);
        }

        setAppointmentsByMonthCount(medicalAppointmentsMonth);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  };

  useEffect(() => {
    fetchAppointments();
  }, [dataInit, dataEnd]);

  return (
    <>
      <Paper
        Icon={PeopleIcon}
        iconColor="blue"
        title={t('dashboard.tabs.users')}
        loading={false}
      >
        <GridContainer justify="center" alignItems="center">
          <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
            <InputMonthPicker
              setStartDate={(date) => setDataInit(date)}
              setEndDate={(date) => setDataEnd(date)}
            />
          </GridItem>
          <GridItem xs={3} sm={3} md={3} lg={3} xl={3}>
            <CSVLink data={csvData}>
              <Button>{t('dashboard.attributes.download_csv')}</Button>
            </CSVLink>
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <GridContainer justify="center" alignItems="center">
          <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h6">
              {t('dashboard.attributes.count_medical_appointments_by_month')}
            </Typography>
            <Bar data={getBarUsersByMonth} options={BarLineOptions} />
          </GridItem>
        </GridContainer>
      </Paper>
    </>
  );
}

export default MedicalReport;
